import { FC } from "react";
import { Outlet } from "react-router-dom";
import StrategiesTreeModelSidebar from "../StrategiesTreeModelSidebar";
import styles from "./StrategiesTreeModelRoot.module.scss";

const StrategiesTreeModelRoot: FC = () => {
  return (
    <>
      <StrategiesTreeModelSidebar />
      <div className={styles.pageWrap}>
        <Outlet />
      </div>
    </>
  );
};

export default StrategiesTreeModelRoot;
